import { ReactNode } from 'react';
import { Stack, StackProps } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

export type CenterDiscProps = {
  /** Diameter in px */
  size: number;
  children?: ReactNode;
} & Omit<StackProps, 'children'>;

export const CircleIconWrapper = ({
  size,
  children,
  sx,
  ...rest
}: CenterDiscProps) => {
  return (
    <Stack
      sx={{
        width: size,
        height: size,
        borderRadius: borderRadius('xl'),
        backgroundColor: t => t.palette.action.selected,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative', // Ensure z-index works if needed
        zIndex: 1, // Sit above radar rings if they are in same context
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Stack>
  );
};
